var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyCheckingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5h-5V40h5V22.5zm15 0h-5V40h5V22.5zM47.5 45H0v5h47.5v-5zm-6.25-22.5h-5V40h5V22.5zM23.75 0L0 12.5v5h47.5v-5L23.75 0zM10.725 12.5L23.75 5.65l13.025 6.85h-26.05z",
    fill: "#006DFF"
  })));
}
export default SvgSkyCheckingIcon;